import { render } from "./CreateClient.vue?vue&type=template&id=dafa8a1e"
import script from "./CreateClient.vue?vue&type=script&lang=js"
export * from "./CreateClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__